import { render } from "./NftDescription.vue?vue&type=template&id=ed5c3fea&scoped=true"
import script from "./NftDescription.vue?vue&type=script&lang=js"
export * from "./NftDescription.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftDescription.scss?vue&type=style&index=0&id=ed5c3fea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5c3fea"]])

export default __exports__